exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../node_modules/css-loader/index.js?modules&camelCase!./common.css"), undefined);

// module
exports.push([module.id, "._11OzWC0pG1DgCjvcjvTtGe{background:url(" + require("../img/Background/plain.png") + ") 50% no-repeat #84db9e;background-size:contain;position:relative;height:100%;width:100%}.Uel5xzF8fKDzbxS_CWGBi{position:absolute;top:18%;width:100%;text-shadow:3px 3px 3px rgba(0,0,0,.6);text-align:center}.ya1I2mVpTq3QRYyauZa-i{width:50%;position:absolute;top:25%;left:25%;background:#fff;border:2px solid #ccc;border-radius:10px;height:60%;overflow-y:auto;padding:0 15px;font-size:2em}._33czqz1tSTN8sibLkInO7c{position:absolute;bottom:5%;left:45%}", ""]);

// exports
exports.locals = {
	"instruction-screen": "_11OzWC0pG1DgCjvcjvTtGe",
	"instructionScreen": "_11OzWC0pG1DgCjvcjvTtGe",
	"title": "Uel5xzF8fKDzbxS_CWGBi",
	"title": "Uel5xzF8fKDzbxS_CWGBi",
	"body": "ya1I2mVpTq3QRYyauZa-i",
	"body": "ya1I2mVpTq3QRYyauZa-i",
	"back-btn": "_33czqz1tSTN8sibLkInO7c " + require("-!../../node_modules/css-loader/index.js?modules&camelCase!./common.css").locals["racer-btn"] + "",
	"backBtn": "_33czqz1tSTN8sibLkInO7c " + require("-!../../node_modules/css-loader/index.js?modules&camelCase!./common.css").locals["racer-btn"] + ""
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&camelCase!./~/postcss-loader!./src/styles/Instructions.css
// module id = 478
// module chunks = 0